import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["children", "label", "status"];

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import styled from 'styled-components';
import Status from '../components/Status';
var SummaryWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])), function (props) {
  return props.backgroundColor && "background-color: ".concat(props.backgroundColor, ";");
}, function (props) {
  return props.borderBottom && "border-bottom: ".concat(props.borderBottom, ";");
}, function (props) {
  return props.paddingBoddy && "padding: ".concat(props.paddingBoddy, ";");
});
var SummaryValue = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n"])), function (props) {
  return props.theme.colors.dark;
}, function (props) {
  return props.theme.fontSizes.xlarge;
});
var SummaryLabel = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n"])), function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.theme.fontSizes.small;
});

var Summary = function Summary(_ref) {
  var children = _ref.children,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? '' : _ref$status,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SummaryWrapper, props, /*#__PURE__*/React.createElement(SummaryValue, null, children), /*#__PURE__*/React.createElement(SummaryLabel, null, status ? /*#__PURE__*/React.createElement(Status, {
    colorScheme: status,
    type: "secondary"
  }, label) : label));
};

export default Summary;